module.exports = __webpack_public_path__ + "img/joinUs_title.8791a20d.png";